export const projectThemesMap: Record<number, string> = {
    1: 'default',
    2: 'redtheme',
    3: 'bluetheme',
    4: 'angolatheme',
    5: 'perutheme',
    6: 'redtheme',
    7: 'theme7',
    8: 'rdotheme',
    9: 'mexicotheme',
    10: 'venezuelatheme',
    11: 'faltheme',
    12: 'greengray',
    13: 'z3theme',
};

export const getSetupTheme = (themeKey?: number) => projectThemesMap[themeKey] || projectThemesMap[1];
